<template xmlns:v-popover="http://www.w3.org/1999/xhtml">
    <div :class="$style.container"
         v-loading.fullscreen.lock.body="loading"
         element-loading-text="拼命加载中"
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.8)">
        <navBar :tags="tags" :title="title" :subTitle="subTitle"
                :cusSubmit="cusSubmit"
                :cusApproval="cusApproval"
                :cusRecall="cusRecall"
                :cusSave="cusSave"
                :btnSubmit="btnSubmit"
                :btnApproval="btnApproval"
                :btnRecall="btnRecall"
                :btnSave="btnSave"
                :btnBack="true"
                @btnSubmitClick="submitStatus('T')"
                @btnApprovalClick="handleApproveClick"
                @btnRecallClick="submitStatus('F')"
                @btnSaveClick="saveScheduleByMonth"
                @btnBackClick="handleBackClick"
        />
        <section :class="$style.body">

            <el-row style="padding-top: 20px">
                <el-col :span="8">
                    <div align="left">
                        <el-button-group :class="$style.month" class="a_modal">
                            <el-button size="small" icon="el-icon-arrow-left"
                                       @click.stop="lastNextMonthClick(-1)"></el-button>
                            <el-button size="small" disabled>{{dateStr}}</el-button>
                            <el-button size="small" icon="el-icon-arrow-right"
                                       @click.stop="lastNextMonthClick(1)"></el-button>
                        </el-button-group>
                    </div>
                </el-col>

                <el-col :span="8">
                    <div align="center">
                        <span style="font-size: 28px;color: #646464">{{dateStr}}</span>
                        <section style="margin-top: 5px">
                            <span :style="{'color':getStatusBackground(tabStatus)}">{{tabStatusStr}}</span>
                        </section>
                    </div>
                </el-col>

                <el-col :span="8">
                    <div align="right">
                        <el-form ref="form" :inline="true">
                            <el-form-item label="店员" prop="area">
                                <el-select v-model="clerk" v-on:change="handleClerkClick" clearable
                                           placeholder="所有店员" size="small" style="width: 160px">
                                    <el-option v-for="item in clerkData" :key="item.user_id"
                                               :label="item.clerk_name"
                                               :value="item.user_id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-form>

                    </div>
                </el-col>

            </el-row>


            <div class="content-page uk-body">
                <div class="calendar">
                    <table class="sign_tab" border="0px" cellpadding="0px" cellspacing="0px">
                        <thead>
                        <tr style="background: #F2F6F9">
                            <td>周日</td>
                            <td>周一</td>
                            <td>周二</td>
                            <td>周三</td>
                            <td>周四</td>
                            <td>周五</td>
                            <td>周六</td>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="item in dateArr" v-if="contains(item)">
                            <template v-for="dataObj in item">
                                <!--<td :class="{'disa':monthClass(dataObj.month), 'cur_day': doCheck(dataObj.date),'check_day': isCheck(dataObj.date) }"-->
                                <!--v-if="isCheck(dataObj.date)">-->
                                <!--<template v-if="doCheck(dataObj.date)">-->
                                <!--今天-->
                                <!--</template>-->
                                <!--<template v-else>-->
                                <!--{{dataObj.date | getCD}}一-->

                                <!--</template>-->
                                <!--<span :class="{'ui-state-down': true }">金币+{{getGold(dataObj.date)}}</span>-->
                                <!--</td>-->

                                <!--<template v-if="(!isCheck(data.date) && (doCheck(data.date) && !hasCheckin))">-->
                                <!--<td v-if="!monthClass(data.month)" @click="checkNow"-->
                                <!--:class="{'disa':monthClass(data.month), 'over':data.date == '', 'cur_day': doCheck(data.date) }">-->
                                <!--今天-->
                                <!--<span :class="{'ui-state-default': true }">点击签到</span>-->
                                <!--</td>-->

                                <!--<td v-else-->
                                <!--:class="{'disa':monthClass(data.month), 'over':data.date == '', 'cur_day': doCheck(data.date) }">-->
                                <!--{{data.date | getCD}}二-->
                                <!--</td>-->


                                <!--</template>-->

                                <!--其他月份为灰色，并禁止点击-->


                                <!--<el-button slot="reference">click 激活</el-button>-->

                                <td :class="{'disa':monthClass(dataObj.month),'other':!monthClass(dataObj.month)}"
                                    @dblclick="dblclick(dataObj)">

                                    <span style="position:absolute;right:10px;top:10px;">{{dataObj.date | getCD}}</span>


                                    <div style="margin-top: 10px;margin-left: 10px" align="left"

                                         v-for="scheduleObj in dataObj.scheduleArray"><!--v-show="!monthClass(dataObj.month)"-->

                                        <section v-show="vshow(scheduleObj.schedule_shift)">
                                            <div style="padding: 2px">
                                                <span :class="$style.span_shift_s"
                                                      :style="{'background':getBackground(scheduleObj.icon_color)}">
                                                    {{scheduleObj.icon_text}}
                                                </span>
                                                <span>{{scheduleObj.last_name}}</span>
                                            </div>
                                        </section>

                                    </div>
                                </td>
                            </template>
                        </tr>
                        </tbody>
                    </table>

                </div>
            </div>


            <div class="channel" align="center">
            <span>
                在某个日期格子中双击编辑当天排班
            </span>
                <section style="margin-top: 5px" class="ware">
                    <div v-for="(item, index) in shiftBArray" :key="index" :label="item" :span="8">
                        <div style="padding: 5px" v-if="item.shift_id">
                            <span :class="$style.span_shift" :style="{'background':getBackground(item.icon_color)}">{{item.icon_text}}</span>
                            <section style="margin-top: 5px">
                                <span>{{item.start_time}}-{{item.end_time}}</span>
                            </section>
                        </div>
                    </div>
                </section>
            </div>

            <el-dialog
                    :visible.sync="dialogVisible"
                    width="35%"
                    :show-close="false"
                    :before-close="handleClose"
                    class="a_modal"
                    style="vertical-align: center;: #FFF9F3">
                <div style="margin-top: -30px">
                    <span style="color: #3998F7;font-weight: bold">日期：{{getWeekDay(scheduleData.date)}}</span>
                    <div class="wrap" style="margin-top: 20px;" v-for="(shiftItem, index) in scheduleData.scheduleArray"
                         :key="index" :label="shiftItem">
                        <span style="width: 60px;text-align:left">{{shiftItem.last_name}}：</span>
                        <div style="padding: 5px">
                            <span :class="$style.span_shift"
                                  :style="{'background':getBackground(shiftItem.icon_color)}">{{shiftItem.icon_text}}</span>
                            <section style="margin-top: 2px">
                                <span style="font-size: 10px" v-if="shiftItem.start_time">{{shiftItem.start_time}}-{{shiftItem.end_time}}</span>
                            </section>
                        </div>
                        <el-select v-model="shiftItem.schedule_shift" v-on:change="handleShiftClick(shiftItem)"
                                   placeholder="请选择班次" :disabled="setDisabled">
                            <el-option
                                    v-for="item in shiftArray"
                                    :key="item.shift_id"
                                    :label="setLable(item)"
                                    :value="item.shift_id">
                            </el-option>
                        </el-select>
                    </div>

                </div>

            </el-dialog>

            <el-dialog
                    title="提交班表"
                    :visible.sync="submitDialog"
                    width="40%"

                    :before-close="handleClose">
                <span>确定要提交当月排班表吗？提交主管后，班表内容将无法再修改</span>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="submitDialog = false">取消</el-button>
                    <el-button type="primary" @click="submitClassTable('T')">立即提交</el-button>
                </span>
            </el-dialog>


            <el-dialog
                    title="审批班表"
                    :visible.sync="approvalDialog"
                    width="50%"
                    :before-close="handleClose">
                <el-row :gutter="24">
                    <el-col :span="12">
                        <div :style="{border: borderAStr}" style="border-radius: 3px;cursor:pointer" class="dialog_wrap"
                             @click="selected(1)">
                            <img :src="stampApproved" width="38px" style="padding: 12px"/>
                            <div>
                                <section style="color: #4A4A4A">同意{{dateStr}}的班表</section>
                                <section style="color: #7ED321;margin-top: 5px">班表立即生效，所有店员可见</section>
                            </div>
                            <img :src="Hook_o" width="15px" style="padding: 12px"/>
                        </div>
                    </el-col>
                    <el-col :span="2"></el-col>
                    <el-col :span="12">
                        <div class="dialog_wrap" :style="{'border':borderRStr}"
                             style="border-radius: 3px;cursor:pointer" @click="selected(2)">
                            <img :src="stampRefused" width="38px" style="padding: 12px"/>
                            <div>
                                <section style="color: #4A4A4A">拒绝{{dateStr}}的班表</section>
                                <section style="color: #D0021B;margin-top: 5px">班表退回店长重新修改</section>
                            </div>
                            <img :src="Circle_o" width="15px" style="padding: 12px"/>
                        </div>
                    </el-col>
                </el-row>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="approvalDialog = false">取消</el-button>
                    <el-button type="primary" @click="submitClassTable('A')">确定</el-button>
                </span>
            </el-dialog>


            <el-dialog
                    title="撤回班表"
                    :visible.sync="recallDialog"
                    width="40%"
                    :before-close="handleClose">
                <span>确定要撤回已经生效的当月排班表吗？撤回后，新的班表需主管重新审批</span>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="recallDialog = false">取消</el-button>
                    <el-button type="danger" @click="submitClassTable('F')">立即撤回</el-button>
                </span>
            </el-dialog>

        </section>
    </div>
</template>
<script>
    import navBar from '../../../components/navBar'
    import http from '../../../APIService/http'
    import moment from 'moment'
    import ApprovedUrl from '../../../assets/images/approved.png'
    import RefusedUrl from '../../../assets/images/refused.png'
    import Hook_o from '../../../assets/images/hook_o.png'
    import Circle_o from '../../../assets/images/circle_o.png'

    export default {
        data() {
            return {
                loading: false,
                tags: ['考勤', '门店详情'],
                title: '门店',
                subTitle: '编辑排班',

                cusSubmit: 'info',//primary
                cusApproval: 'info',
                cusRecall: 'info',
                cusSave: 'info',

                btnSubmit: true,
                btnApproval: true,
                btnRecall: true,
                btnSave: true,

                id: '',
                clerk: '',
                clerkData: [],
                tableData: [],
                scheduleData: {},
                shiftArray: [],
                shiftBArray: [],
                dateOne: {},
                dateStr: "",

                tabStatusStr: '',
                tabStatus: '',
                today: new Date(),
                year: '',
                month: '',
                day: '',
                date: '',
                startTime: '',
                endTime: '',
                dateArr: [],
                hasCheckin: false,

                dialogVisible: false,
                submitDialog: false,
                recallDialog: false,
                approvalDialog: false,

                stampApproved: ApprovedUrl,
                stampRefused: RefusedUrl,
                Hook_o: Hook_o,
                Circle_o: Circle_o,
                borderAStr: 'solid 1px #FF9901',
                borderRStr: 'solid 1px #FFFFFF',
                buttenStatus: '',
                isSelected: 1,
                isEdit:false
            }
        },
        props: ['checkin'],

        filters: {
            getCD(val) {
                return val.split('-')[2]
            }
        },


        watch: {
            dateArr: {
                deep: true,
                handler: function (val, oldVal) {

                    this.startTime = val[0][0].date;
                    this.endTime = val[5][6].date;
                    this.setMonth(this.year + '-' + this.month, [this.startTime, this.endTime]);
                }
            }
        },
        components: {
            navBar
        },
        computed: {
            isDisabled() {
                if (this.message) {
                    return false
                }
                return true
            },
            setDisabled(){

                if(this.cusSave === 'info'){
                    return true
                }
                return false
            },
        },
        created() {

            let obj = this.$store.getters.getStore
            this.id = obj.id
            this.title = obj.storeName

            if(obj.dateOne){
                this.dateOne = obj.dateOne
            }else {
                this.dateOne = moment()
            }
            this.dateStr = this.getCurrentDate()


            this.year = this.today.getFullYear();
            this.month = this.today.getMonth() + 1;
            this.day = this.today.getDay();
            this.date = this.today.getDate();

            this.getCalendar();

            this.getClassTable()
            this.getSchedulingData()
        },
        methods: {

            getCurrentDate() {

                let date = moment(this.dateOne)
                return date.year() + '年' + this.getFormatDate(date.month() + 1) + '月'

            },
            lastNextMonthClick(num) {

                let currentDate = moment(this.dateOne)
                let date = currentDate.add(num, "months")
                this.dateOne = date
                this.dateStr = date.year() + '年' + this.getFormatDate(date.month() + 1) + '月'

                this.year = date.year()
                this.month = this.getFormatDate(date.month() + 1)
                this.getCalendar();

                this.getClassTable()
                this.getSchedulingData()
            },
            getFormatDate(arg) {

                if (!arg) {
                    return '';
                }
                var re = arg + '';
                if (re.length < 2) {
                    re = '0' + re;
                }
                return re;
            },
            async getClassTable() {

                try {

                    let data = {
                        store_id: this.id,
                        tenant_id: this.$store.getters.getUser.tenant_id,
                        month: this.dateOne.format("YYYY-MM")
                    }
                    this.tableData = []

                    await http.post('/wapi/v1/getClassTable', data).then(res => {

                        this.tabStatus = res.data.status

                        this.cusSubmit = 'info'
                        this.cusApproval = 'info'
                        this.cusRecall = 'info'
                        this.cusSave = 'info'

                        //判断当前人是否为店长
                        let userObj = this.$store.getters.getUser


                        switch (this.tabStatus) {
                            case "SUBMITTED"://已提交

                                this.tabStatusStr = '班表已提交待审'

                                if (userObj.role !== 'manager') {
                                    this.cusApproval = 'success'
                                    this.cusSave = 'primary'
                                }

                                break
                            case "APPROVED"://已批准

                                this.tabStatusStr = '班表已审核生效'


                                if (userObj.role !== 'manager') {
                                    this.cusRecall = 'danger'
                                    this.cusSave = 'primary'
                                }


                                break;
                            case "REJECTED"://已拒绝或已撤回

                                this.tabStatusStr = '班表已撤回'

                                this.cusSubmit = 'primary'
                                this.cusSave = 'primary'


                                break;
                            default://未提交
                                this.tabStatusStr = '班表尚未提交'


                                this.cusSubmit = 'primary'
                                this.cusSave = 'primary'

                        }
                    })
                    //
                } catch (err) {
                    this.loading = false
                    console.log(`error:${err}`)
                }
            },
            async saveScheduleByMonth() {//保存排班表

                if (this.cusSave === 'info') {//阻止保存
                    return
                }

                this.loading = true
                try {

                    let data = {
                        store_id: this.id,
                        tenant_id: this.$store.getters.getUser.tenant_id,
                        month: this.dateOne.format("YYYY-MM"),
                        dateArray: this.dateArr
                    }
                    this.tableData = []

                    await http.post('/wapi/v1/saveScheduleByMonth', data).then(res => {

                        if (res.success) {
                            this.$message({
                                type: 'success',
                                message: '保存成功'
                            })
                        }

                        //判断是否点击了保存
                        if(this.buttenStatus){
                            this.isEdit = false
                            this.submitClassTable(this.buttenStatus)
                        }else {
                            this.loading = false
                        }


                    })
                    //
                } catch (err) {
                    this.loading = false
                    console.log(`error:${err}`)
                }
            },
            handleApproveClick() {

                if (this.cusApproval !== 'info') {
                    this.approvalDialog = true
                }


            },
            submitStatus(status) {

                if (status === 'T') {
                    if (this.cusSubmit !== 'info') {
                        this.submitDialog = true
                    }
                } else {
                    if (this.cusRecall !== 'info') {
                        this.recallDialog = true
                    }
                }

            },
            async submitClassTable(status) {//提交撤回

                //判断是否有过编辑,先保存后提交
                if(this.isEdit){

                    this.buttenStatus = status

                    this.saveScheduleByMonth()

                    return
                }else {
                    this.buttenStatus = ''
                }

                let statusStr = ''

                if (status === 'A') {//代表审批

                    if (this.isSelected === 1) {//通过
                        statusStr = 'APPROVED'
                    } else {
                        statusStr = 'REJECTED'
                    }
                    this.approvalDialog = false
                } else {//代表提交和撤回
                    if (status === 'T') {
                        statusStr = 'SUBMITTED'
                        this.submitDialog = false
                    } else {
                        statusStr = "REJECTED"
                        this.recallDialog = false
                    }
                }

                this.loading = true

                try {

                    let data = {
                        store_id: this.id,
                        tenant_id: this.$store.getters.getUser.tenant_id,
                        month: this.dateOne.format("YYYY-MM"),
                        status: statusStr,
                        user_id: this.$store.getters.getUser.user_id,
                    }

                    await http.post('/wapi/v1/submitClassTable', data).then(res => {

                        if (res.success) {

                            let message = ''
                            if (status === 'T') {
                                message = '提交成功'
                            } else if (status === 'F') {
                                message = "撤回成功"
                            } else {
                                if (this.isSelected === 1) {
                                    message = '班表已同意'
                                } else {
                                    message = '班表已拒绝'
                                }

                                //恢复默认
                                this.isSelected = 1
                                this.Hook_o = Hook_o
                                this.Circle_o = Circle_o
                                this.borderAStr = 'solid 1px #FF9901'
                                this.borderRStr = 'solid 1px #FFFFFF'
                            }

                            this.$message({
                                type: 'success',
                                message: message
                            })

                            this.getClassTable()


                        }

                        this.loading = false

                    })
                    //
                } catch (err) {
                    this.loading = false
                    console.log(`error:${err}`)
                }
            },
            async getSchedulingData() {
                this.loading = true

                try {

                    let data = {
                        store_id: this.id,
                        clerk: this.clerk,
                        month: this.dateOne.format("YYYY-MM"),
                        user_id: this.$store.getters.getUser.user_id,
                        tenant_id: this.$store.getters.getUser.tenant_id,
                        dayArray: this.dateArr
                    }
                    this.tableData = []

                    await http.post('/wapi/v1/getSchedulingData', data).then(res => {

                        this.dateArr = res.data.resultArray

                        this.shiftArray = res.data.shiftArray
                        this.shiftBArray = res.data.shiftBArray

                        this.clerkData = res.data.clerk_list

                        this.$store.commit('setStore', {
                            id: this.id,
                            dateOne:this.dateOne,
                            storeName: this.title,
                            shiftArray:this.shiftBArray
                        })

                        this.loading = false


                    })
                    //
                } catch (err) {
                    this.loading = false
                    console.log(`error:${err}`)
                }
            },
            // 点击详情
            handleDetail(index, row) {
                // this.$store.commit('setStore', {
                //     id: row.store_id,
                //     storeName: row.name
                // })
                this.$router.push({
                    path: '/attendance/approveInfo',
                    query: {
                        row: row
                    }
                })

            },
            vshow(schedule_shift) {

                if (schedule_shift) {

                    return true
                }
                return false
            },
            dblclick(dataObj) {//双击事件
                if (dataObj.month === 'cur') {
                    this.dialogVisible = true
                    this.scheduleData = dataObj
                }
            },
            selected(num) {
                this.isSelected = num
                if (num === 1) {
                    this.borderAStr = 'solid 1px #FF9901'
                    this.borderRStr = 'solid 1px #FFFFFF'

                    this.Hook_o = Hook_o;
                    this.Circle_o = Circle_o;

                } else {
                    this.borderAStr = 'solid 1px #FFFFFF'
                    this.borderRStr = 'solid 1px #FF9901'
                    this.Hook_o = Circle_o;
                    this.Circle_o = Hook_o;
                }
            },
            handleClose(done) {
                // this.$confirm('确认关闭？')
                //     .then(_ => {
                //         done();
                //     })
                //     .catch(_ => {});
                done();
                // this.$forceUpdate()
            },
            setLable(item) {
                if (item.start_time) {
                    return item.icon_text + " " + item.start_time + "-" + item.end_time
                } else {
                    return item.icon_text
                }
            },
            handleClerkClick() {//选择店员
                this.getCalendar();
                this.getSchedulingData()
            },
            handleShiftClick(shiftItem) {

                this.isEdit = true

                for (let obj of this.shiftArray) {
                    if (shiftItem.schedule_shift === obj.shift_id) {
                        if (!obj.shift_id) {
                            shiftItem.key_id = ''
                        }
                        shiftItem.icon_text = obj.icon_text
                        shiftItem.icon_color = obj.icon_color
                        shiftItem.start_time = obj.start_time
                        shiftItem.end_time = obj.end_time
                        shiftItem.start_time_tolerance = obj.start_time_tolerance
                        shiftItem.end_time_tolerance = obj.end_time_tolerance
                    }
                }

            },
            getStatus(status) {

                switch (status) {
                    case 'AWAIT':
                        return '待审批'
                    case 'APPROVE':
                        return '已批准'
                    case 'REFUSE':
                        return '已拒绝'
                }

            },

            // 修改班次的背景色
            getBackground(color) {
                return 'rgb(' + color + ')'
            },
            // 修改班表状态颜色
            getStatusBackground(str) {

                switch (str) {
                    case "SUBMITTED"://已提交

                        return '#4A90E2'
                    case "APPROVED"://已批准

                        return '#7ED321'

                    case "REJECTED"://已拒绝或已撤回

                        return '#D0021B'
                    default://未提交

                        return '#D0021B'
                }
            },
            // 返回按钮
            handleBackClick() {
                this.$router.push({
                    path: '/attendance'
                })
            },
            //签到
            checkNow() {
                this.$emit('checkIn')
            },

            setMonth(date,) {
                this.$emit('setMonth', date, [this.startTime, this.endTime])
            },

            monthClass(type) {
                if (type !== 'cur') {
                    return true
                } else {
                    return false

                }
            },

            getGold(thisDay) {
                for (let i in this.checkin) {
                    var d = new Date(this.checkin[i].time);
                    var _ymd = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();

                    if (new Date(thisDay).getTime() == new Date(_ymd).getTime()) {
                        return this.checkin[i].amount;
                    }
                }
            },

            isLeap() {
                const year = this.year;
                if (year % 4 > 0) {
                    return false;
                }
                else if (year % 100 == 0 && year % 400 > 0) {
                    return false;
                }
                else {
                    return true;
                }

            },
            getWeekDay(date) {
                let day = ''
                if (!date) {
                    return day
                }
                let num = moment(date).format('d')

                switch (num) {
                    case '0':
                        day = '星期日'
                        break
                    case '1':
                        day = '星期一'
                        break
                    case '2':
                        day = '星期二'
                        break
                    case '3':
                        day = '星期三'
                        break
                    case '4':
                        day = '星期四'
                        break
                    case '5':
                        day = '星期五'
                        break
                    case '6':
                        day = '星期六'
                        break

                }
                return this.scheduleData.date + "  " + day
            },
            getLen(m) {
                const month = m || this.month;
                if (month == 2) {
                    if (this.isLeap()) {
                        return 29;
                    } else {
                        return 28;
                    }
                } else {
                    if (month < 8) {
                        if (month % 2 > 0) {
                            return 31;
                        } else {
                            return 30;
                        }
                    } else {
                        if (month % 2 > 0) {
                            return 30;
                        } else {
                            return 31;
                        }
                    }
                }
            },
            getCalendar() {

                var len = this.getLen();
                var d = new Date(this.year, this.month - 1, 1);
                var dfw = d.getDay();
                var arr = new Array();
                var tem = 0;
                var nextTem = 1;
                var pre = dfw - 1

                let date = moment(this.dateOne)


                var _lastLen = this.getLen(this.month - 1)


                for (var i = 0; i < 6; i++) {
                    arr[i] = new Array();
                    for (var j = 0; j < 7; j++) {

                        tem++;
                        if (tem - dfw > 0 && tem - dfw <= len) {
                            arr[i][j] = {
                                date: this.year + '-' + (this.getFormatDate(date.month()+1)) + '-' + (this.getFormatDate(tem - dfw)),
                                month: 'cur',
                                scheduleArray: []
                            };
                        } else {
                            if (tem <= dfw) {

                                if(date.month() === 0){

                                    let dateC = moment(this.dateOne)
                                    let dateNew = dateC.add(-1, "months")

                                    arr[i][j] = {
                                        date: dateNew.year() + '-' + (this.getFormatDate(dateNew.month()+1)) + '-' + (_lastLen - pre),
                                        month: 'pre',
                                        scheduleArray: []
                                    };
                                }else {
                                    arr[i][j] = {
                                        date: this.year + '-' + (this.getFormatDate(date.month())) + '-' + (_lastLen - pre),
                                        month: 'pre',
                                        scheduleArray: []
                                    };
                                }

                                pre--;

                            } else {

                                if(date.month() === 11){

                                    let dateC = moment(this.dateOne)
                                    let dateNew = dateC.add(1, "months")

                                    arr[i][j] = {
                                        date: dateNew.year() + '-' + this.getFormatDate(dateNew.month() + 1) + '-' + this.getFormatDate(nextTem),
                                        month: 'next',
                                        scheduleArray: []
                                    };
                                }else {
                                    arr[i][j] = {
                                        date: this.year + '-' + this.getFormatDate(date.month() + 2) + '-' + this.getFormatDate(nextTem),
                                        month: 'next',
                                        scheduleArray: []
                                    };
                                }

                                nextTem++

                            }
                        }
                    }
                }

                //判断是否有第6行

                let dayObj = arr[5]
                let monthStr = dayObj[0].date.substring(0,7)
                let mStr = moment(this.dateOne).format("YYYY-MM")
                if(monthStr !== mStr){
                    arr.splice(5)
                }

                this.dateArr = arr;
                // console.log(this.dateArr);

            },
            contains(arr) {
                if ((arr[0] == '') && (arr[1] == '') && (arr[2] == '') && (arr[3] == '') && (arr[4] == '') && (arr[5] == '') && (arr[6] == '')) {
                    return false;
                } else {
                    return true;
                }
            }
        }
    }
</script>
<style lang="scss" module>
    @import '../../../assets/css/default';

    .container {
        background: #fff;
        padding: 20px 20px;
        height: 100%;
        box-sizing: border-box;
        .body {

            .title {
                font-size: $fontSize;
                line-height: $fontSize;
                em {
                    display: inline-block;
                    margin-right: 50px;
                    color: #000000;
                }
                span {
                    display: inline-block;
                    color: #4a90e2;
                    margin-right: 30px;
                }
            }
            .month {
                margin-bottom: 15px;
            }
            .text {
                font-size: 14px;
                color: #4D586D;
            }
            .bottom {

                .table {
                    margin-top: 15px;
                }
                .pagination {
                    margin-top: 50px;
                    text-align: center;
                }
            }
            .span_shift_s {
                font-size: 8px;
                color: #FFFFFF;
                border-radius: 3px;
                padding: 4px;
                -webkit-transform: scale(0.8);
                display: -moz-inline-box;
                display: inline-block;
                text-align: center;
                line-height: 15px;
                width: 40px;
            }
            .span_shift {
                font-size: 12px;
                color: #FFFFFF;
                border-radius: 3px;
                padding: 4px;
                display: -moz-inline-box;
                display: inline-block;
                text-align: center;
                line-height: 15px;
                width: 50px;
            }
        }
    }
</style>
<style scoped>

    .a_modal >>> .el-button {
        color: #646464;
    }

    .a_modal >>> .el-select {
        width: 60%;
    }

    .channel {
        margin-top: 20px;
        font-size: 12px;
        color: #808080;
        vertical-align: middle;
    }

    .ware {
        display: flex;
        justify-content: center;
    }

    .dialog_wrap {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .wrap {
        display: flex;
        justify-content: space-between;
        text-align: center;
        align-items: center;
    }


</style>
<style rel="stylesheet/scss" lang="scss">
    .calendar {
        width: 100%;
        margin: 0px 0px 20px 0px;
        color: #555;
        position: relative;
    }

    .calendar h4 {
        line-height: 40px;
        background-color: #fff;
        text-align: center;
        color: #333;
        box-shadow: 0 0 4px #bbb;
        -webkit-box-shadow: 0 0 4px #bbb;
    }

    .calendar button {
        position: absolute;
        width: 30px;
        height: 30px;
        top: 5px;
        color: #777;
        background: #f3f3f3;
        border: none;
    }

    .calendar button:focus {
        border: none;
        outline: none;
    }

    .calendar button.month-less {
        left: 10px;
    }

    .calendar button.month-add {
        right: 10px;
    }

    .calendar .sign_tab {
        width: 100%;
        border-collapse: collapse;
        border: 1px solid #e8e8e8;
        border-top: 0;
        table-layout: fixed;

    }

    .calendar .sign_tab th {
        text-align: center;
        height: 14.28571428571429vw;
        font-weight: 700;
    }

    .calendar .sign_tab td {
        position: relative;
        border: 1px solid #eee;
        padding: 15px 0;
        text-align: center;
        font-size: 14px;
        font-family: arial;
    }

    .calendar .sign_tab td.over {
        background-color: #fff;
        border-left: 0;
        border-right: 0;
    }

    .calendar .sign_tab td.disa {
        color: #ccc;
        background: none;
        height: 50px;
        * {
            color: #ccc;
            right: 10px;
            top: 10px;
        }

    }

    .calendar .sign_tab td.other {
        height: 50px;
        cursor: pointer;
        color: #646464;
    }

    .calendar .sign_tab td.check_day {
        background-color: #f8f8f8;
        color: #58ce7a;
        position: relative;
    }

    .calendar {
        .ui-state-down,
        .ui-state-default {
            font-size: 10px;
            width: 100%;
            text-align: center;
            position: absolute;
            bottom: 3px;
            left: 0;
        }
        .ui-state-down {
            color: #f60;
        }
    }

    .calendar .ui-state-up {
        font-size: 10px;
        width: 100%;
        text-align: center;
        position: absolute;
        top: 3px;
        left: 0;

    }

    .calendar .sign_tab td.cur_day {
        background-color: #FFD2D2;
        color: #FFF;
    }

    .checkin-btn {
        display: block;
        width: 90%;
        margin: 0 auto;
        text-align: center;
        font-size: 10px;
    }
</style>




// WEBPACK FOOTER //
// src/pages/attendance/editScheduling/index.vue